module.exports = __webpack_public_path__ + "static/media/MSME Infographic desktop 22-20-2024 C.eb315d4b.gif";